const radii = {
  none: "0",
  s: "0.25rem",
  m: "0.5rem",
  l: "1rem",
  full: "4rem",
};

export default radii;
